// 来店につながる行動を数える
//
// 実店舗のサイトなので、いちばん来店に近いのは「電話を押す」「地図を開く」。
// これまで一度も数えていなかったため、どのページが来店を生んでいるか分からなかった。
//
// 送り先はアクセス解析（GA4・G-WL26RG6FG7）。計測タグは本番でしか出力しないため、
// ローカルやテスト環境では何も起きない（gtag が無ければ黙って何もしない）。
(function () {
	function send(name, params) {
		if (typeof window.gtag !== 'function') return;
		params = params || {};
		params.page_path = location.pathname;
		window.gtag('event', name, params);
	}

	// その要素がページのどこにあるか。
	// 同じ電話番号でも、本文の中にあるものとフッターにあるものは意味が違う。
	function where(el) {
		if (el.closest('footer')) return 'footer';
		if (el.closest('header')) return 'header';
		if (el.closest('.p-front-access, .p-co-access, #access')) return 'access';
		return 'body';
	}

	document.addEventListener('click', function (e) {
		var a = e.target.closest ? e.target.closest('a') : null;
		if (!a) return;
		var href = a.getAttribute('href') || '';

		// 周辺店舗の紹介リンク（体験・観光ページ）。
		// この中にもGoogleマップへのリンクがあるため、自店の地図より先に判定する。
		// 順番を逆にすると、よその店の地図を「自店の地図を開いた数」に数えてしまう。
		if (a.closest('.p-ex-links')) {
			send('nearby_shop_link', { link_url: href });
			return;
		}

		// 電話 ── 来店・注文にいちばん近い行動
		if (href.indexOf('tel:') === 0) {
			send('tel_tap', { link_location: where(a) });
			return;
		}

		// 地図 ── 来店の直前行動
		if (href.indexOf('google.com/maps') > -1 || href.indexOf('maps.google.com') > -1) {
			send('map_open', { link_location: where(a) });
			return;
		}

		// Instagram ── サイトからSNSへ戻る動き
		if (href.indexOf('instagram.com') > -1) {
			send('instagram_click', { link_location: where(a) });
			return;
		}
	}, true);

	// お問い合わせの送信完了。
	// これまではページが開かれた回数しか分からず、送られたかは数えていなかった。
	document.addEventListener('wpcf7mailsent', function () {
		send('contact_submit', {});
	}, false);

	// 地図の埋め込み（iframe）は、クリックをこちらで拾えない。
	// 代わりに「地図が画面に入ったか」を1回だけ数え、見られているかの目安にする。
	if ('IntersectionObserver' in window) {
		var maps = document.querySelectorAll('iframe[src*="google.com/maps"]');
		if (maps.length) {
			var io = new IntersectionObserver(function (entries) {
				entries.forEach(function (en) {
					if (!en.isIntersecting) return;
					send('map_view', {});
					io.unobserve(en.target);
				});
			}, { threshold: 0.5 });
			maps.forEach(function (m) { io.observe(m); });
		}
	}
})();
